import CimsQuickLinkEntityTable from 'components/CIMSTable/common/components/CimsQuickLinkEntityTable'
import {
  useGetDsQuickLinksQuery,
  useEditDsQuickLinkMutation,
  useCreateDsQuickLinkMutation,
  useSoftRemoveDsQuickLinkMutation,
  useRestoreDsQuickLinkMutation,
} from 'schema'
import { Permission } from '@cims-online/shared'

const DSQuickLinks: React.FC = () => (
  <CimsQuickLinkEntityTable
    entity="Design Submittal"
    query={useGetDsQuickLinksQuery}
    getQuickLinks={(data) => data?.dsQuickLinks?.records ?? []}
    create={{
      permission: Permission.CreateDesignSubmittalQuickLink,
      mutation: useCreateDsQuickLinkMutation,
      getLabel: ({ createDSQuickLink: create }) => create.dsQuickLink,
    }}
    edit={{
      permission: Permission.EditDesignSubmittalQuickLink,
      mutation: useEditDsQuickLinkMutation,
      getLabel: ({ editDSQuickLink: edit }) => edit.dsQuickLink,
    }}
    remove={{
      permission: Permission.RemoveRestoreDesignSubmittalQuickLink,
      mutation: useSoftRemoveDsQuickLinkMutation,
      getLabel: ({ softRemoveDSQuickLink: remove }) => remove.dsQuickLink,
    }}
    restore={{
      permission: Permission.RemoveRestoreDesignSubmittalQuickLink,
      mutation: useRestoreDsQuickLinkMutation,
      getLabel: ({ restoreDSQuickLink: restore }) => restore.dsQuickLink,
    }}
  />
)

export default DSQuickLinks
